import { createAction, type Dispatch } from '@reduxjs/toolkit';
import { api } from '@/lib/trpc/client';
import type { HowToContentResult, HowToContentService } from '@/server/api/routers/stage-content';

type HowtoContentPayload = {
  contentMapped: HowToContentResult;
  service: HowToContentService;
};

type ErrorObject = {
  message?: string;
  data?: {
    code?: string;
  };
};

export const howtoContentRequestStarted = createAction('howto-content/request/started');
export const howtoContentRequestFailed = createAction<string>('howto-content/request/failed');
export const fetchHowtoContentSucceeded = createAction<HowtoContentPayload>(
  'howto-content/fetch/succeeded'
);

function getTrcpErrorMessage(error: ErrorObject) {
  return String(error?.message || error?.data?.code || 'Unknown error');
}

export const fetchHowtoContent =
  (service: 'assortments' | 'pim' | 'supplement-orders') => (dispatch: Dispatch) => {
    dispatch(howtoContentRequestStarted());

    return api.stageContent.howToContent
      .query({
        service,
      })
      .then(
        ({ result }) => {
          dispatch(fetchHowtoContentSucceeded({ contentMapped: result, service }));
        },
        (error: ErrorObject) => dispatch(howtoContentRequestFailed(getTrcpErrorMessage(error)))
      );
  };
